import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '@services/shared.service';
import { GiftcardModel } from '@shared/models/GiftcardModel';
import { IBenefits } from '@shared/models/Interfaces';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-package-benefit-detail-modal',
    templateUrl: './package-benefit-detail-modal.component.html',
    styleUrls: ['./package-benefit-detail-modal.component.scss']
})
export class PackageBenefitDetailModalComponent implements OnInit {

    selectedBenefit: IBenefits;
    @ViewChild('showBenefitDetail', { static: true }) modal: any;
    private showBenefitDetailModalSubscription: Subscription = null;

    allStores = [1, 2, 3];

    constructor(private modalService: NgbModal,
        public sharedService: SharedService) { }

    ngOnInit(): void {

        this.showBenefitDetailModalSubscription = this.sharedService.showBenefitDetailModal.subscribe((benefit: IBenefits) => {

            if (benefit != null) {
                
                // set object complete
                this.selectedBenefit = benefit;                
                this.openModal();
            }
        });
    }

    ngOnDestroy() {

        if (this.showBenefitDetailModalSubscription) { this.showBenefitDetailModalSubscription.unsubscribe(); }
    }

    _isGiftcardModel(data: any): data is GiftcardModel {
        return (data as GiftcardModel).id !== undefined;
    }

    openModal() {
        this.modalService.open(this.modal, {
            keyboard: true,
            size: 'xs', centered: true, windowClass: 'modal-full'
        });
    }

    closeModal() {

        this.selectedBenefit = null;
        this.modalService.dismissAll();
    }

}
